import React, { useState, useEffect } from 'react';
import Layout from '../../components/layout';
import Seo from '../../components/seo';
import { graphql } from 'gatsby';
import { csv } from 'd3-fetch';
import { scaleBand, scaleLinear } from 'd3-scale';
import { max } from 'd3-array';
import Loading from '../../components/loading';
import WorldCupScore from '../../components/worldCup/worldCupScore'
import Heading from '../../components/heading';

const WorldCup = ({ data }) => {
    const location1 = data.allFile.nodes[0].publicURL
    const location2 = data.allFile.nodes[1].publicURL
    const [worldCupDataPreview, setWorldCupDataPreview] = useState(null);
    const [worldCupDataScore, setWorldCupDataScore] = useState(null);
    const [width, setWidth] = useState(400);
    const margin = ({ top: 20, bottom: 20, left: 40, right: 20 })
    const height = 600;
    const updateDimensions = () => {
        setWidth(window.outerWidth);
    }
    useEffect(() => {
        csv(location1).then(value => {
            (
                setWorldCupDataPreview(
                    value.map(a => (
                        {
                            Yindex: a.Year,
                            TotalScore: +a.GoalsScored,
                            Winner: a.Winner
                        })))
            )
        })
    }, [location1])
    useEffect(() => {
        csv(location2).then(value => {
            (
                setWorldCupDataScore(
                    value.map(a => (
                        {
                            Year: a.Year,
                            TotalScore: +a['Total Goals'],
                            Yindex: a.Country,
                            Finish: a.Finish,
                            Organizer: a.Organizer
                        })))
            )
        })
    }, [location2])
    useEffect(() => {
        setWidth(window.outerWidth);
        window.addEventListener("resize", updateDimensions);
        return () => window.removeEventListener("resize", updateDimensions);
    }, []);
    const xScale = worldCupDataPreview ? scaleLinear()
        .domain([0, max(worldCupDataPreview, d => d.TotalScore)])
        .range([0, width - 80])
        : null
    const yScale = worldCupDataPreview ? scaleBand()
        .domain(worldCupDataPreview.map(a => a.Yindex))
        .padding(0.3)
        .range([margin.top + 20, height])
        : null
    return (
        <Layout>
            <Seo title="World Cup" />
            <Heading heading="World Cup Chart" />
            <div>
                <p>84 year long history of world cup goals and the winners.Total goals scored in the final tournament
                    and the world cup winners.
                </p>
                {worldCupDataPreview ?
                    <div className="my-2 sm:my-4 my-6 rounded black dark:bg-gray-500 bg-gray-100 ">
                        <svg
                            width={width - 50}
                            height={height}>
                            <text key="xScale" x={width / 3} y={margin.top - 5}>
                                Total Goals Per Tournament →
                            </text>
                            <text key="yScale" x={margin.left - 34} y={margin.top + 5}>
                                Year ↑
                            </text>
                            {
                                yScale.domain().map((a, index) => (
                                    <g key={`yTickGroup-${index}`}>
                                        <text
                                            className="xs:text-xs text-sm"
                                            dy="0.35em"
                                            key={`yTickName-${index}`}
                                            x={margin.left - 29}
                                            y={yScale(a) + yScale.bandwidth() / 2}>
                                            {a}
                                        </text>
                                    </g>
                                ))
                            }
                            {
                                xScale.ticks().map((a, index) => (
                                    <g key={`xScaleTips-${index}`}
                                        transform={`translate(${margin.left},0)`}>
                                        <line
                                            className="stroke-current text-gray-400 dark:text-white"
                                            key={`tickLine-${index}`}
                                            x1={xScale(a)}
                                            y1={margin.top + 20}
                                            x2={xScale(a)}
                                            y2={height}
                                        />
                                        <text
                                            className="xs:text-xs text-sm"
                                            key={`xScaleText-${index}`}
                                            x={xScale(a)}
                                            y={margin.top + 18}
                                            textAnchor="middle">
                                            {a}
                                        </text>

                                    </g>
                                ))
                            }
                            {worldCupDataPreview.map((a, index) => (
                                <g key={`topGrouping-${index}`}
                                    className="fill-current text-red-500 dark:text-gray-700">
                                    <rect
                                        key={`goals-${index}`}
                                        x={margin.left}
                                        y={yScale(a.Yindex)}
                                        width={xScale(a.TotalScore)}
                                        height={yScale.bandwidth()}>
                                        <title key={`helperTextRect-${index}`}>
                                            {a.TotalScore}
                                        </title>
                                    </rect>
                                    <text
                                        key={`GoalScoredText-${index}`}
                                        className="text-gray-200 dark:text-white font-bold"
                                        x={xScale(a.TotalScore)}
                                        y={yScale(a.Yindex) + yScale.bandwidth() / 2}
                                        dy="0.35em">
                                        {a.TotalScore}
                                    </text>
                                    <text
                                        key={`GoalScoredTextWinner-${index}`}
                                        className="text-gray-200 dark:text-white font-bold"
                                        x={xScale(a.TotalScore) / 3}
                                        y={yScale(a.Yindex) + yScale.bandwidth() / 2}
                                        dy="0.35em">
                                        {a.Winner}
                                    </text>
                                </g>
                            ))}
                            <rect key="index"
                                className="fill-current text-red-500 dark:text-gray-700"
                                x={width / 1.5}
                                y={height / 10}
                                width="90"
                                height={yScale.bandwidth()}>
                            </rect>
                            <text
                                className="fill-current text-gray-200 dark:text-white font-bold"
                                x={(width / 1.5) + 10}
                                y={(height / 10) + yScale.bandwidth() / 1.4}>Winners</text>
                        </svg>
                    </div>
                    : <Loading />
                }
            </div>
            <p>
                Let's dive little deeper. Added individual country performance per year and overall countries performance
                in the world cup finals.Just click on the bars to dig deeper
            </p>
            <WorldCupScore
                margin={margin}
                totalScoreData={worldCupDataPreview}
                individualYearData={worldCupDataScore}
                width={width - 50}
                givenHeight={height}
            />
        </Layout>
    )

}

export const query = graphql`
            query WorldCupQuery {
                allFile(filter: {base: {regex: "/.*WorldCups_preview|World_cup_scores.*/" } }) {
                nodes {
                publicURL
            }
        }
}`

export default WorldCup